module.exports = __webpack_public_path__ + "static/media/title-1@2x.aea06508.png";